var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"name-code"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.params?.name || _vm.params?.displayName || ''))]),(_vm.code)?_c('span',{staticClass:"code"},[_vm._v("- "+_vm._s(_vm.code))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }